import styled from 'styled-components';
import { FONTS, COLORS } from '../../styles';

export const PicksContainer = styled.div`
  padding-top: 0.5rem;
`;

export const ContentPadding = styled.div`
  padding-top: 2rem;
`;

export const NotStartedText = styled.p`
  margin: 0;
  font-family: ${FONTS.BLOCKLETTER};
  font-size: 1.5rem;
  color: ${COLORS.DISABLED_GRAY};
`;

export const OwnerPicksContainer = styled.div`
  width: 80%;
`;
